const search = {
    offset: 0,
    init() {
        this.events();
    },
    events() {
        /**
         * Execute events
         */
        this.loadInitial();
    },    
    loadInitial() {
        var self = this;    
        this.ajaxCall('clear', 'none', 'none');
        jQuery('#mtf-category').on('change', function(){
            self.offset = 0;
            self.ajaxCall('clear', jQuery(this).val(), jQuery('#mtf-sort').val());
        });
        jQuery('#mtf-sort').on('change', function(){
            self.offset = 0;
            self.ajaxCall('clear', jQuery('#mtf-category').val(), jQuery(this).val());
        });
        jQuery('.loadmore-button').on('click', function(){
            self.offset++;
            self.ajaxCall('loadmore', jQuery('#mtf-category').val(), jQuery('#mtf-sort').val());
        });
    },
    ajaxCall(action, category, sort) {
        var self = this; 
        jQuery('.mtf-loader').addClass('show');
        jQuery.ajax({
            url: mtf_ajax_object.ajax_url,
            type: "POST",
            data: {
                'action': 'ajax_get_posts',
                'category': category,
                'sort': sort,
                'offset': (self.offset)*6
            },
            dataType: "json"
        }).done(function(data){
            var html = '';
            jQuery('.mtf-loader').removeClass('show');
            jQuery(data).each(function(index, element){
                html += '<div class="col-lg-6">';
                    html += '<div class="col-lg-12 search-holder">';
                        html += '<h2>'+element.title+'</h2>';
                        html += '<p>'+element.excerpt+'</p>';
                        html += '<div class="actions">';
                            html += '<a href="'+element.link+'" class="yellow-btn">Read More</a>';
                            html += '<div class="date">'+element.date+'</div>';
                        html += '</div>';
                        html += '<div class="image" style="background-image: url('+element.image+')"></div>';
                    html += '</div>';
                html += '</div>';
            });
            if(action === 'loadmore'){
                jQuery('.load-search-items').append(html); 
            } else {
                jQuery('.load-search-items').html(html); 
            }    
            if(data.length < 6){
                jQuery('.loadmore-button').addClass('hide');
            } else {                
                jQuery('.loadmore-button').removeClass('hide');
            }
        }).fail(function(event){
            console.log(event);
        });
    }
};
jQuery(() => {
    search.init();
});